import {get} from "lodash"

/**
 *
 * Default error messages
 *
 */

const DEFAULT_MESSAGE = "PBERRUnknownError"

/**
 *
 * @param err
 * @param defaultMessage
 * @returns {*}
 * @private
 */
export const insightsErrorHandler = (err, defaultMessage = DEFAULT_MESSAGE) => {
  err.contentKey = `errors.${get(err, "response.data.code", defaultMessage)}`
  throw err
}


/**
 * Default service export
 */
export default {
  insightsErrorHandler
}
